<template>
  <v-list class="py-0">
    <v-progress-linear v-if="loading" indeterminate absolute />
    <template v-if="anyResources">
      <v-card class="folder-list-toolbar rounded-0 px-4 pt-3 pb-2" variant="flat">
        <FilterSearch :query-key="'resource_search'" :limit-width="false" />

        <div class="folder-list-toolbar__filters d-flex flex-wrap align-center ga-2 mt-2">
          <v-chip-group v-model="selection" mandatory color="primary"
            class="folder-list-chip-group flex-grow-1 flex-shrink-1">
            <v-chip v-for="chip in filterChipsOptions" :key="'chip' + chip.value" :value="chip.value" size="small"
              variant="tonal" class="mr-1 mb-1">
              {{ chip.text }}
            </v-chip>
          </v-chip-group>

          <v-btn v-if="hasFilters" size="x-small" variant="outlined" color="error" class="flex-shrink-0 mb-1"
            prepend-icon="mdi-filter-off" @click="resetFilter()">
            {{ $t("text.clear") }}
          </v-btn>
        </div>
      </v-card>

      <Folder :folder="typeFilteredResources" :total-search-count="searchResultCount" :wide="wide" />
      <div v-if="numberOfHiddenFiles" class="d-flex flex-column justify-center align-center flex-wrap px-3 py-16">
        <small style="opacity: 0.7">{{ $t("text.did_you_not_find_what_you_where_looking_for") }}</small>
        <small style="opacity: 0.7">
          <b class="text-primary">{{ numberOfHiddenFiles }}</b>
          {{ $t("text.files_hidden_by_filter") }}
        </small>
        <v-btn size="small" variant="text" color="primary" class="px-1" @click="resetFilter()">{{
          $t("text.clear_filter")
        }}</v-btn>
      </div>
    </template>

    <div v-else class="pa-3">No resources available for this equipment.</div>
  </v-list>
</template>

<script>
import Folder from "@/components/Folder.vue";
import FilterSearch from "@/components/Inputs/FilterSearch.vue";
import FolderMixin from "@/helpers/mixins/FolderMixin.js";

export default {
  name: "FolderList",
  props: {
    allowed: Boolean,
    resources: Object,
    loading: Boolean,
    wide: Boolean,
  },
  components: {
    FilterSearch,
    Folder,
  },
  mixins: [FolderMixin],

  data() {
    return {
      selection: 0,
      searchFilteredResources: this.resources,
      typeFilteredResources: this.resources,
    };
  },

  methods: {
    resetFilter() {
      this.selection = 0;
      this.$router.replace({ query: { ...this.$route.query, resource_search: undefined } });
    },

    filter() {
      if (!this.resources) {
        return;
      }
      var copy = JSON.parse(JSON.stringify(this.resources));
      this.searchFilteredResources = this.filterFiles(this.searchword, null, copy);
      var copy2 = JSON.parse(JSON.stringify(this.searchFilteredResources));
      this.typeFilteredResources = this.filterFiles(null, this.selection, copy2);
    },
  },

  computed: {
    anyResources() {
      return (
        (this.resources.Files && this.resources.Files[0]) ||
        (this.resources.Folders && this.resources.Folders[0])
      );
    },

    searchword() {
      return this.$route.query?.resource_search;
    },

    filterChipsOptions() {
      return this.chipOptions(this.searchFilteredResources);
    },

    searchResultCount() {
      return this.countFilesByType(null, this.typeFilteredResources);
    },

    numberOfHiddenFiles() {
      return this.countFilesByType(null, this.resources) - this.searchResultCount;
    },

    hasFilters() {
      return Boolean(this.searchword) || this.selection !== 0;
    },
  },

  watch: {
    searchword() {
      this.filter();
    },
    selection() {
      this.filter();
    },
    loading() {
      this.filter();
    },
  },
};
</script>

<style scoped>
.folder-list-toolbar :deep(.v-field) {
  border-radius: 8px;
}

.folder-list-chip-group {
  min-width: 0;
}
</style>
